<template>
  <div>
    <b-card>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loading"
      >
        <b-row class="mb-1">
          <b-col md="4">
            <b-button variant="success" class="mr-1" @click="openModal">
              Create Category
            </b-button>
            <b-button
              class="btn-icon rounded-circle"
              variant="flat-primary"
              @click="fetchCategories"
            >
              <feather-icon icon="RefreshCwIcon" />
            </b-button>
          </b-col>
        </b-row>

        <b-table
          fixed
          :fields="tableColumns"
          :items="categories"
          class="mb-2 text-center"
          show-empty
          empty-text="No matching records found"
        >
          <template #cell(name)="data">
            <span class="font-weight-bolder">{{ data.item.name }}</span>
          </template>

          <template #cell(benefit_en)="data">
            <span v-if="data.item.benefit_en">{{ data.item.benefit_en }}</span>
            <span v-else class="text-muted">-</span>
          </template>

          <template #cell(benefit_ar)="data">
            <span v-if="data.item.benefit_ar">{{ data.item.benefit_ar }}</span>
            <span v-else class="text-muted">-</span>
          </template>

          <template #cell(amount)="data">
            <b-badge pill variant="light-success" class="text-capitalize">
              {{ data.item.amount }} {{ data.item.currency || "" }}
            </b-badge>
          </template>

          <template #cell(code)="data">
            <b-badge
              v-if="data.item.code"
              pill
              variant="light-info"
              class="text-capitalize"
            >
              {{ data.item.code }}
            </b-badge>
            <span v-else class="text-muted">-</span>
          </template>

          <template #cell(group_segment_name)="data">
            <span v-if="data.item.group_segment_name">{{
              data.item.group_segment_name
            }}</span>
            <span v-else class="text-muted">-</span>
          </template>

          <template #cell(actions)="data">
            <b-dropdown variant="link" no-caret>
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="openEditModal(data.item)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="openDeleteModal(data.item)">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </b-overlay>
    </b-card>

    <!-- Create/Edit Form Modal -->
    <extra-payment-form
      ref="extraPaymentForm"
      :category="selectedCategory"
      :is-edit-mode="isEditMode"
      @success="fetchCategories"
    />

    <!-- Delete Confirmation Modal -->
    <delete-extra-payment-modal
      :category="selectedCategory"
      @deleted="fetchCategories"
    />
  </div>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BOverlay,
  BRow,
  BTable,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import ExtraPaymentForm from "../components/ExtraPaymentForm.vue";
import DeleteExtraPaymentModal from "../components/DeleteExtraPaymentModal.vue";
import useExtraPaymentCategories from "../hooks/useExtraPaymentCategories";

export default {
  components: {
    ExtraPaymentForm,
    DeleteExtraPaymentModal,
    BButton,
    BTable,
    BBadge,
    BRow,
    BCol,
    BCard,
    BOverlay,
    BDropdown,
    BDropdownItem,
  },
  setup(_, ctx) {
    return {
      ...useExtraPaymentCategories(ctx),
    };
  },
};
</script>
